
import { Component, Vue } from 'vue-property-decorator';
import PageContainer from '@/components/PageTemplate/PageContainer.vue';
import PageTableOfContents from '@/components/PageTemplate/PageTableOfContents.vue';

@Component({
  components: {
    PageContainer,
    PageTableOfContents,
  },
})
export default class Drivers extends Vue {
  get sectorLinks() {
    return [
      {
        sections: [
          {
            name: 'Municipal & Industrial',
            routeName: 'municipalIndustrial',
          },
        ],
      },
      {
        sections: [
          {
            name: 'Agricultural',
            routeName: 'agriculturalSector',
          },
        ],
      },
      {
        sections: [
          {
            name: 'Environmental & Recreational',
            routeName: 'envRecSector',
          },
        ],
      },
      {
        sections: [
          {
            name: 'Overlap in Sectors',
            routeName: 'overlapSector',
          },
        ],
      },
    ];
  }
}
